import { withRouter } from 'react-router-dom';
import PostsSection from './PostsSection';
import PostsSectionContainer from './PostsSection.container';

export default withRouter(PostsSectionContainer(PostsSection));
